import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AiSuggestionStateService {
  readonly disabled = signal<boolean>(false);
}
